import $ from 'jquery';
import { standardizeHeights } from '../../core/INF-gridAlignment';

const CollectionGrid = () => {
  if ($('[data-section-type="INF-CollectionGrid"]').length === 0) {
    return;
  }

  const grid_item_selector = '[data-product-tile]';
  const child_selectors = [
    '[data-product-tile-image]',
    '[data-product-tile-title]',
    '[data-product-tile-price]',
  ];
  
  $(window).on('resize', () => {
    standardizeHeights(grid_item_selector, child_selectors);
  });
};

export { CollectionGrid };
